const config = {
  routes: {
    label: 'Privacy Notice',
    prefix: '/privacy_notice_new',
  },
}

export default config
